import React from 'react'
import { observer } from 'mobx-react-lite'
import { Routes, Route } from 'react-router-dom'
import MeetingEdit from './MeetingEdit'
import MeetingLst from './MeetingLst'
import MeetingsCalendar from './MeetingsCalendar'
/**
 * @function MeetingsMain
 * @description Main routing component for the Meetings module. Maps routes to different meeting views including list, edit, view, and calendar modes.
 * @returns {JSX.Element} A React element containing nested routes for the meetings interface.
 */
const MeetingsMain = () => {
	return (
		<Routes>
			<Route path=":itmId/*">
				<Route path="edit" element={<MeetingEdit />} />
				<Route path="view" element={<MeetingEdit viewOnly={true} />} />
			</Route>
			<Route index element={<MeetingLst />} />
			<Route path="calendar" element={<MeetingsCalendar />} />
			<Route path="*" element={<div>Not found</div>} />
		</Routes>
	)
}
export default observer(MeetingsMain)
